import { render, staticRenderFns } from "./invite-user-add-or-update.vue?vue&type=template&id=0f0c1d02&scoped=true&"
import script from "./invite-user-add-or-update.vue?vue&type=script&lang=js&"
export * from "./invite-user-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0c1d02",
  null
  
)

export default component.exports